import React from "react";

export default function AboutProjectEn() { return <div dangerouslySetInnerHTML={{ __html: "" }} />; }
